import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "777d6ee8-c6d7-4c68-8155-70bfa091910f",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    shuffle: true,
    type: "number",
    prefixText: "The <b>modulus of the reflection coefficient</b> is",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 0.33,
};
